export const useQuery = (input) => {
  return new URLSearchParams(input);
};
